import {Col, Row, Tooltip} from 'antd';
import {Footer} from 'antd/lib/layout/layout';
import Title from 'antd/lib/typography/Title';
import moment from 'moment';
import getConfig from 'next/config';
import Image from 'next/image';
import Link from 'next/link';
import {FC} from 'react';
import {useIntl} from 'react-intl';
import {dev} from '../../apollo/ApolloSetup';
import {Tenant, TENANT} from '../../tenant/tenant';
import {FOOTER_LOGO} from '../../tenant/tenant-logos';
import {COPYRIGHT_NAME, TENANT_NAME} from '../../tenant/tenant-names';
import {TENANT_WEBSITE} from '../../tenant/tenant-website';
import {LocaleSelection} from './locale-selection';
import {defaultNavigation} from './navigation';
import styles from './page-wrapper.module.scss';

const { publicRuntimeConfig } = getConfig();

export const AveliosFooter: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.footer}>
      <Footer
        className={styles.contentWrapper}
        style={{
          backgroundColor: '#011034',
          color: 'white',
        }}
      >
        <div className={styles.content}>
          <Row style={{ marginTop: 22, flexDirection: "row-reverse" }} gutter={25} justify="space-between">
            <Col lg={4} xs={12} style={{ marginBottom: 32 }}>
              <Title className={styles.footerTitle} level={3}>
                {formatMessage({ id: 'footer.navigation' })}
              </Title>
              {defaultNavigation.map((i) => (
                  <div key={i.key}>
                    <Link href={i.key}>{formatMessage({ id: i.labelKey })}</Link>
                  </div>
              ))}
              <Title className={styles.footerTitle} level={3} style={{ marginTop: 20 }}>
                {formatMessage({ id: 'footer.credits' })}
              </Title>
              <div>
                <Link href={'/credits'}>{formatMessage({ id: 'footer.credits.external' })}</Link>
              </div>
            </Col>
            <Col lg={4} xs={12} >
              <Title className={styles.footerTitle} level={3}>
                {formatMessage({ id: 'footer.about-avelios-medical' }, { tenant: TENANT_NAME })}
              </Title>
              <div>
                <a href={TENANT_WEBSITE} target={'_blank'} rel={'noreferrer'}>
                  {TENANT_NAME}
                </a>
              </div>
              {TENANT === Tenant.avelios && (
                <div>
                  <a
                    href={'https://www.linkedin.com/company/avelios-medical'}
                    target={'_blank'}
                    rel={'noreferrer'}
                  >
                    LinkedIn
                  </a>
                </div>
              )}
              <div>
                <Link href={'/legal-notice'} target={'_blank'} rel={'noreferrer'}>
                  {formatMessage({ id: 'footer.imprint' })}
                </Link>
              </div>
              <div>
                <a href={'/terms-of-service.pdf'} target={'_blank'} rel={'noreferrer'}>
                  {formatMessage({ id: 'footer.terms-of-usage' })}
                </a>
              </div>
              <div>
                <a href={'/privacy.pdf'} target={'_blank'} rel={'noreferrer'}>
                  {formatMessage({ id: 'footer.privacy' })}
                </a>
              </div>
            </Col>
            <Col lg={3} xs={12} >
              <Title className={styles.footerTitle} level={3}>
                {formatMessage({ id: 'footer.language' }, { tenant: TENANT_NAME })}
              </Title>
              <LocaleSelection />
            </Col>
          </Row>

          <div
              style={{
                position: 'relative',
                height: 50,
                marginBottom: 20,
                marginTop: 24,
              }}
          >
            <Image src={FOOTER_LOGO} alt={TENANT_NAME} layout={'fill'} objectFit={'contain'} />
          </div>
          <Row style={{ textAlign: 'center' }}>
            <Col span={24}>
              Copyright © {moment().year()} {COPYRIGHT_NAME}{' '}
              {dev && (
                  <div>
                    <Tooltip title={'Only visible in dev mode'}>
                      <small>{`v.${publicRuntimeConfig?.version}`}</small>
                    </Tooltip>
                  </div>
              )}
            </Col>
          </Row>
        </div>
      </Footer>
    </div>
  );
};
